import { Spin as SpinBase } from 'antd';
import { SpinProps } from 'antd/lib/spin';
import React from 'react';

export interface ISpinProps extends SpinProps {
  children?: React.ReactNode;
}

const Spin: React.FC<ISpinProps> = ({ children, ...props }) => {
  return <SpinBase {...props}>{children}</SpinBase>;
};

export default Spin;
